const TRANSLATIONS_EN = {
    serviceDateFieldLabel: 'Service date',
    serviceDateIsRequired: 'Service date is required'
};

export default TRANSLATIONS_EN;
